import { injectReducer } from 'store/reducers'
import { injectSagas } from 'store/sagas'

export default (store) => ({
  path: 'grid',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const GridTool = require('./containers/GridToolContainer').default

      const gridReducer = require('containers/Grid/modules/reducer').default
      const gridSagas = require('containers/Grid/modules/sagas').sagas
      injectReducer(store, { key: 'grid', reducer: gridReducer })
      injectSagas(store, { key: 'grid', sagas: gridSagas })

      const gridWithToolbarReducer = require('containers/GridWithToolbar/modules/reducer').default
      const gridWithToolbarSagas = require('containers/GridWithToolbar/modules/sagas').sagas
      injectReducer(store, { key: 'gridWithToolbar', reducer: gridWithToolbarReducer })
      injectSagas(store, { key: 'gridWithToolbar', sagas: gridWithToolbarSagas })

      const gridWithToolbarWithOnboardingReducer = require('containers/GridWithToolbarWithOnboarding/modules/reducer').default
      const gridWithToolbarWithOnboardingSagas = require('containers/GridWithToolbarWithOnboarding/modules/sagas').sagas
      injectReducer(store, { key: 'gridWithToolbarWithOnboarding', reducer: gridWithToolbarWithOnboardingReducer })
      injectSagas(store, { key: 'gridWithToolbarWithOnboarding', sagas: gridWithToolbarWithOnboardingSagas })

      /*  Return getComponent   */
      cb(null, GridTool)

    /* Webpack named bundle   */
    }, 'GridTool')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/GridTool/index.js
 **/